import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import { useRadioGroup } from './useRadioGroup.js';

var RadioGroup = /*#__PURE__*/forwardRef(function RadioGroup(props, ref) {
  var _cn;

  var _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'vertical' : _props$orientation;

  var _useRadioGroup = useRadioGroup(props),
      container = _useRadioGroup.container,
      options = _useRadioGroup.options;

  var classNames = cn('yt-radio-group', (_cn = {}, _cn["yt-radio-group--orientation-" + orientation] = !!orientation, _cn['space-x-4'] = orientation === 'horizontal', _cn), props.className);
  return createElement("div", Object.assign({}, container, {
    className: classNames,
    ref: ref
  }), options.map(function (option, i) {
    var container = option.container,
        input = option.input,
        text = option.text;
    var radioContainerClassName = cn('flex items-center font-normal h-8', {
      'text-grey-dark': input.disabled
    });
    var radioLabelClassName = cn('yt-radio__label cursor-pointer ml-2 text-sm', {
      'cursor-not-allowed': input.disabled
    });
    return createElement("span", {
      className: radioContainerClassName,
      key: i
    }, createElement("span", Object.assign({}, container, {
      className: "yt-radio"
    }), createElement("input", Object.assign({}, input)), createElement("span", {
      className: "yt-checkmark"
    })), text && createElement("span", {
      className: radioLabelClassName,
      onClick: container.onClick
    }, text));
  }));
});

export { RadioGroup };
//# sourceMappingURL=RadioGroup.js.map
